import { callSources, voiceShares } from '../data/callSources';
import type { AgentMetrics, CallSource, CallSourceInfo, VoiceSource, VolumePoint } from '../types/voip';

export const sourceTone: Record<CallSource, { dot: string }> = {
  voip: { dot: 'bg-src-voip' },
  five9: { dot: 'bg-src-five9' },
  bland: { dot: 'bg-src-bland' },
};

export function sourceInfo(id: CallSource): CallSourceInfo {
  return callSources.find((s) => s.id === id) ?? callSources[0];
}

export function sourceLabel(id: CallSource): string {
  return sourceInfo(id).label;
}

/** Portion of an agent's metrics that came through a single voice source */
export function sourceMetrics(m: AgentMetrics, source: VoiceSource): AgentMetrics {
  const s = voiceShares[source];
  return {
    outbound: Math.round(m.outbound * s.outbound),
    inbound: Math.round(m.inbound * s.inbound),
    missed: Math.round(m.missed * s.missed),
    talkSeconds: Math.round(m.talkSeconds * s.talkSeconds),
  };
}

export function sourceVolume(points: VolumePoint[], source: VoiceSource): VolumePoint[] {
  const s = voiceShares[source];
  return points.map((p) => ({
    label: p.label,
    outbound: Math.round(p.outbound * s.outbound),
    inbound: Math.round(p.inbound * s.inbound),
    missed: Math.round(p.missed * s.missed),
  }));
}
